import { render, staticRenderFns } from "./MvpStageResult.vue?vue&type=template&id=1c1f36bb&"
import script from "./MvpStageResult.vue?vue&type=script&lang=js&"
export * from "./MvpStageResult.vue?vue&type=script&lang=js&"
import style0 from "./MvpStageResult.vue?vue&type=style&index=0&id=1c1f36bb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports